import { Navigate, useLocation } from 'react-router-dom';

// Legacy chat URLs (/inappchat, /chat-v2) hard-redirect to /inbox so stale
// bookmarks and history never land on the retired PubNub inbox. The query
// string is preserved for /chat-v2?conversation_id=<uuid> deep links.
const LegacyChatRedirect = () => {
  const location = useLocation();
  return (
    <Navigate to={{ pathname: '/inbox', search: location.search }} replace />
  );
};

export default LegacyChatRedirect;
